export default __webpack_public_path__ + "static/media/CollapseMenuIcon.1e449a80.svg";